import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { UserSchema } from '../entities/user';

import { getUsersPaginated } from './__mocked_data__/users-state';

export namespace GetUsersQuery {
  export const key = (input: Input) => [
    'user-management',
    'users',
    input.page,
    input.pageSize,
  ];

  export type Input = { page: number; pageSize: number };

  export const OutputSchema = z.object({
    totalCount: z.number(),
    previousPage: z.number().optional(),
    currentPage: z.number(),
    nextPage: z.number().optional(),
    users: z.array(
      UserSchema.pick({
        id: true,
        firstName: true,
        lastName: true,
        email: true,
        active: true,
        lastLogin: true,
        role: true,
      }),
    ),
  });
  export type Output = z.infer<typeof OutputSchema>;

  function outputMapper(input: Input): Output {
    const result = getUsersPaginated(input);

    return result;
  }

  function useQueryFn() {
    return async function queryFn(input: Input) {
      const output = await OutputSchema.parseAsync(outputMapper(input));
      return output;
    };
  }

  export function useQuery(input: Input) {
    const queryFn = useQueryFn();

    return rq.useQuery<Output>({
      queryKey: key(input),
      queryFn: () => queryFn(input),
      keepPreviousData: true,
    });
  }

  export function usePrefetch() {
    const queryClient = rq.useQueryClient();
    const queryFn = useQueryFn();

    return async function prefetch(input: Input): Promise<void> {
      await queryClient.prefetchQuery<Output>({
        queryKey: key(input),
        queryFn: () => queryFn(input),
      });
    };
  }
}
